import { render, staticRenderFns } from "./DiceSimulator.vue?vue&type=template&id=53a9b940&scoped=true&"
import script from "./DiceSimulator.vue?vue&type=script&lang=js&"
export * from "./DiceSimulator.vue?vue&type=script&lang=js&"
import style0 from "./DiceSimulator.vue?vue&type=style&index=0&id=53a9b940&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a9b940",
  null
  
)

export default component.exports